import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { INTERESTS, getInterestLabel } from '../../constants/interests';
import t from '../../i18n/useTranslation';
import './InterestPickerModal.css';

function InterestPickerModal({
    value = [],
    onClose,
    onSave,
    max = 15,
    language = 'español',
    accent = '#ff6b35'
}) {
    // Snapshot: copiamos `value` solo en el mount inicial. Durante la edición
    // ignoramos cambios externos del padre — el usuario no debe perder
    // selecciones in-flight si el padre re-renderiza por cualquier motivo.
    // Para resetear el contenido se desmonta el modal (pasar `key` distinta
    // desde el padre si se quiere reiniciar).
    const [draft, setDraft] = useState(() => Array.isArray(value) ? [...value] : []);

    const labels = {
        title: t.interestPicker?.title || 'Selecciona tus intereses',
        subtitle: t.interestPicker?.subtitle || 'Marca todos los que quieras',
        max: t.interestPicker?.max || `Máximo ${max}`,
        accept: t.interestPicker?.accept || 'Aceptar',
        cancel: t.interestPicker?.cancel || 'Cancelar',
        limitReached: t.interestPicker?.limitReached || 'Límite alcanzado'
    };

    const toggle = (key) => {
        setDraft(prev => {
            if (prev.includes(key)) return prev.filter(k => k !== key);
            if (prev.length >= max) return prev;
            return [...prev, key];
        });
    };

    const handleAccept = (e) => {
        e?.stopPropagation();
        onSave(draft);
        onClose();
    };

    const handleCancel = (e) => {
        e?.stopPropagation();
        onClose();
    };

    const content = (
        <div className="ipick-overlay" onClick={handleCancel}>
            <div className="ipick-modal" onClick={e => e.stopPropagation()}>
                <div className="ipick-header" style={{ borderTopColor: accent }}>
                    <div>
                        <h3>{labels.title}</h3>
                        <p className="ipick-sub">{labels.subtitle}</p>
                    </div>
                    <span className="ipick-counter" style={{ color: accent }}>
                        {draft.length}/{max}
                    </span>
                </div>

                <div className="ipick-body">
                    <div className="ipick-grid">
                        {INTERESTS.map(key => {
                            const checked = draft.includes(key);
                            const disabled = !checked && draft.length >= max;
                            return (
                                <label
                                    key={key}
                                    className={`ipick-item ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
                                    style={checked ? { borderColor: accent, background: accent + '14' } : undefined}
                                >
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        disabled={disabled}
                                        onChange={() => toggle(key)}
                                    />
                                    <span className="ipick-label">
                                        {getInterestLabel(key, language)}
                                    </span>
                                    <span
                                        className="ipick-check"
                                        style={checked ? { background: accent, borderColor: accent } : undefined}
                                    >
                                        {checked && (
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                                <path d="M5 12l5 5L20 7" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        )}
                                    </span>
                                </label>
                            );
                        })}
                    </div>
                </div>

                <div className="ipick-footer">
                    <button className="ipick-btn ipick-btn-cancel" onClick={handleCancel}>
                        {labels.cancel}
                    </button>
                    <button
                        className="ipick-btn ipick-btn-accept"
                        style={{ background: accent }}
                        onClick={handleAccept}
                    >
                        {labels.accept}
                    </button>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(content, document.body);
}

export default InterestPickerModal;
